import React from "react";
import ImperiumLogo from "../image/ImperiumLogo.png";

function SolutionsTopnav() {
  return (
    <div className="fixed z-50 flex-col top-0 bg-white w-full border-b-[1px] border-[#EEEEEE] backdrop-blur-md bg-opacity-30 shadow-lg">
      <div className="h-[70px] top_section flex justify-between items-center">
        <a href="https://imperiumapp.com/" target="_blank" rel="noopener noreferrer"><img className="w-[120px]" src={ImperiumLogo} alt="" /></a>

        <div className="solutions-head flex items-center gap-4">
          <a href="https://imperiumapp.com/about" target="_blank">
            ABOUT
          </a>
          <a href="https://imperiumapp.com/contact" target="_blank">
            CONTACT
          </a>
        </div>
      </div>
    </div>
  );
}

export default SolutionsTopnav;
